import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func, shape, string } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Spin } from 'grab-ui';
import { bindCallback } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { processLoginTokenAction } from 'actions/process-login-actions';
import { enableUIV2 } from 'helper/configuration';
import { verifyingTokenErrorsSelector } from '../selectors/login-selector';

import { retrieveLKPPTokenAction } from '../actions/login-actions';

import InacessibleModal from '../components/inacessible-login-modal/inacessible-login-modal';
import styles from './verify-lkpp-view.less';

export class VerifyLKKPTokenView extends Component {
  static propTypes = {
    location: shape({}).isRequired,
    verifyingTokenErrors: string,
    history: shape({}).isRequired,
    retrieveLKPPToken: func.isRequired,
    processLoginToken: func.isRequired,
  };

  static defaultProps = {
    verifyingTokenErrors: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isVerifyingToken: false,
      isVisibleAccessibleModal: false,
      isLinkingFailed: false,
    };
    this.isAdmin = false;
    this.errors = '';
  }

  componentDidMount() {
    this.getURLParams();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.verifyingTokenErrors !== this.props.verifyingTokenErrors) {
      if (this.props.verifyingTokenErrors.includes('token already exchanged')) {
        this.errors =
          'Maaf telah terjadi kesalahan, silakan coba login kembali.';
      } else {
        this.errors =
          'Akun Anda belum terdaftar, silahkan hubungi admin Anda untuk registrasi akun di sistem Operator.';
      }
      this.handleVerifyingTokenState();
    }
  }

  getURLParams = () => {
    const { history } = this.props;
    const query = new URLSearchParams(this.props.location.search);
    const token = query.get('nonce');
    if (token) {
      this.setState({
        isVerifyingToken: true,
      });
      this.verifyingLKKPToken(token);
    } else {
      history.push('/login');
    }
  };

  handleVerifyingTokenState = () => {
    this.setState({
      isVerifyingToken: !this.state.isVerifyingToken,
    });
  };

  suspendLKKPLogin = () => {
    this.isLogining = false;
    this.setState({
      isVisibleAccessibleModal: true,
      isLinkingFailed: true,
    });
  };

  verifyingLKKPToken = nonce => {
    const { retrieveLKPPToken, processLoginToken, history } = this.props;

    // Convert retrieveLKPPToken method callback to observable
    bindCallback(retrieveLKPPToken)(nonce)
      .pipe(
        switchMap(({ data }) => bindCallback(processLoginToken)(data.token)),
      )
      .subscribe(([err, result]) => {
        if (err) {
          this.suspendLKKPLogin();
        } else if (enableUIV2()) {
          // V2
          history.push('/home');
        } else {
          // V1
          const { canViewBooking } = result;
          if (canViewBooking) {
            history.push('/bookings');
          } else {
            this.isLogining = false;
            this.setState({
              isVisibleAccessibleModal: true,
              isLinkingFailed: false,
            });
          }
        }
      });
  };
  closeInaccessbibleModal = () => {
    this.setState({
      isVisibleAccessibleModal: !this.state.isVisibleAccessibleModal,
      isLinkingFailed: !this.state.isLinkingFailed,
    });
  };
  render() {
    const {
      isVerifyingToken,
      isVisibleAccessibleModal,
      isLinkingFailed,
    } = this.state;
    return (
      <div className={styles.content}>
        {isVerifyingToken && <Spin size="large" />} <p>{this.errors}</p>
        <InacessibleModal
          isVisibleAccessibleModal={isVisibleAccessibleModal}
          closeInaccessbibleModal={this.closeInaccessbibleModal}
          isAdmin={this.isAdmin}
          isLinkingFailed={isLinkingFailed}
        />
      </div>
    );
  }
}
export const mapStateToProps = state => ({
  verifyingTokenErrors: verifyingTokenErrorsSelector(state),
});
export const mapDispatchToProps = dispatch => ({
  retrieveLKPPToken: (token, callback) =>
    dispatch(retrieveLKPPTokenAction(token, callback)),
  processLoginToken: (token, callback) =>
    dispatch(processLoginTokenAction(token, callback)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VerifyLKKPTokenView),
);
